export const attachDateInputGuard = () => {
    document.addEventListener(
        'input',
        (e) => {
            const target = e.target;

            if (target.tagName !== 'INPUT' || target.type !== 'date') return;

            const value = target.value;
            if (!value) return;

            const year = value.split('-')[0];

            if (year && year.length > 4) {
                // Only revert if previous value exists
                const prev = target.getAttribute('data-prev') || '';
                target.value = prev;
            } else {
                // Store last valid value
                target.setAttribute('data-prev', value);
            }
        },
        true // 👈 important: capture phase
    );
};